<template>
  <v-app id="inspire">
    <Loader />
    <!-- eslint-disable-next-line vue/require-component-is -->
    <component v-bind:is="currentDrawer" />
    <GlobalToolBar />
    <v-content>
      <ContentNotification />
      <v-container fluid fill-height>
        <v-layout justify-center align-start>
          <Snackbar />
          <router-view />
        </v-layout>
      </v-container>
    </v-content>
    <AdBlockerFoundModal :visible="adblockerModalVisible" @close="onClose" />
  </v-app>
</template>

<script>
import GlobalToolBar from '@/components/Shared/ToolBar/ToolBar'
// サイドバー
import AdminDrawer from '@/components/Shared/Drawer/AdminDrawer'
import LoginLpDrawer from '@/components/Shared/Drawer/LoginLpDrawer'
import AdvertiserDrawer from '@/components/Shared/Drawer/AdvertiserDrawer'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

import Loader from '@/components/Shared/Loader'
import Snackbar from '@/components/Shared/Snackbar'

import ContentNotification from '@/components/Shared/ToolBar/ContentNotification'

import { getters } from '@/vuex/modules/ui/drawer/constants'
import {
  actions as colorThemeActions,
  getters as colorThemeGetters,
} from '@/vuex/modules/ui/colorTheme/constants'

import AdBlockerFoundModal from '@/components/Shared/Modal/AdBlockerFoundModal'
import localStorage from 'store'

export default {
  metaInfo() {
    return {
      title: this.brandTitle,
      link: [
        {
          rel: 'shortcut icon',
          type: 'image/png',
          href: this.favicon,
        },
      ],
    }
  },
  components: {
    GlobalToolBar,
    // eslint-disable-next-line vue/no-unused-components
    AdminDrawer,
    // eslint-disable-next-line vue/no-unused-components
    LoginLpDrawer,
    // eslint-disable-next-line vue/no-unused-components
    AdvertiserDrawer,
    Loader,
    Snackbar,
    ContentNotification,
    AdBlockerFoundModal,
  },
  data() {
    return {
      adblockerModalVisible: false,
    }
  },
  computed: {
    currentDrawer() {
      return this.$store.getters[getters.drawerType]
    },
    openFlg() {
      return this.$store.getters[getters.showFlag]
    },
    brandTitle() {
      return this.$store.getters[colorThemeGetters.brandTitle]
    },
    favicon() {
      return this.$store.getters[colorThemeGetters.favicon]
    },
    themeColor() {
      return this.$store.getters[colorThemeGetters.color]
    },
  },
  watch: {
    themeColor: {
      handler() {
        this.applyThemeColor()
      },
      deep: true,
    },
  },
  async created() {
    await this.$store.dispatch(colorThemeActions.INITIALIZE)
    this.applyThemeColor()
    await this.checkAdBlocker()
  },
  methods: {
    applyThemeColor() {
      this.$vuetify.theme = {
        ...this.$vuetify.theme,
        ...this.themeColor,
      }
    },
    async checkAdBlocker() {
      try {
        // adBlockerが入っている場合、以下のリクエストは失敗する
        // それを利用して、adBlockerを検出する
        await fetch(
          'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
        )
      } catch (e) {
        // 「次回からこのメッセージを表示しない」を選択したことがある場合、AdBlocker検出のmodalを表示しない
        const checkDateTime = localStorage.get(
          'GeologicAdmin.adblocker.hideNotification.isCheck',
        )

        // 未チェックの場合
        if (checkDateTime === undefined) {
          await this.onDetectAdBlocker()
          return
        }

        const currentDate = dayjs().tz('Asia/Tokyo')
        const targetDate = dayjs(checkDateTime).tz('Asia/Tokyo')
        const oneMonth = dayjs.duration(1, 'month')
        const thresholdDate = targetDate.add(oneMonth)

        // 最後にチェックしてから１ヶ月以上経っている場合
        if (currentDate.isAfter(thresholdDate)) {
          await this.onDetectAdBlocker()
        }
      }
    },
    async onDetectAdBlocker() {
      this.adblockerModalVisible = true
    },
    onClose(isChecked) {
      if (isChecked) {
        localStorage.set(
          'GeologicAdmin.adblocker.hideNotification.isCheck',
          new Date(),
        )
      }
      this.adblockerModalVisible = false
    },
  },
}
</script>
